export default __webpack_public_path__ + "static/gallery-img1-f862864c24bde768e170d07c19594412.jpg";